const DetailModal = ({ item, onClose, onAddToCart }) => {
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* 모달 본체 */}
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "white",
          borderRadius: "16px",
          width: "600px",
          maxWidth: "90vw",
          maxHeight: "85vh",
          overflowY: "auto",
          boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* 닫기 버튼 */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "16px 16px 0 16px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "22px",
              cursor: "pointer",
              color: "#888",
              lineHeight: 1,
            }}
          >
            ✕
          </button>
        </div>

        {/* 이미지 */}
        <div
          style={{
            width: "100%",
            aspectRatio: "4 / 3",
            backgroundColor: "#f5f5f5",
            overflow: "hidden",
          }}
        >
          <img
            src={item.image || "/placeholder.jpg"}
            alt={item.name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>

        {/* 내용 */}
        <div style={{ padding: "24px" }}>
          {/* 이름 */}
          <h2 style={{ margin: "0 0 12px 0", fontSize: "22px", color: "#032063" }}>{item.name}</h2>

          {/* 뱃지 */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "20px" }}>
            <span
              style={{
                padding: "4px 14px",
                backgroundColor: "#f0f0f0",
                borderRadius: "16px",
                fontSize: "13px",
              }}
            >
              {item.series}
            </span>
            <span
              style={{
                padding: "4px 14px",
                backgroundColor: "#e3f2fd",
                borderRadius: "16px",
                fontSize: "13px",
              }}
            >
              {item.model}
            </span>
            <span
              style={{
                padding: "4px 14px",
                backgroundColor: "#f3e5f5",
                borderRadius: "16px",
                fontSize: "13px",
              }}
            >
              {item.format}
            </span>
            {item.price !== null && (
              <span
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#032063",
                  marginLeft: "auto",
                }}
              >
                {item.price.toLocaleString()}원
              </span>
            )}
          </div>
          {/* 가격 */}
          {/* {item.price && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 16px",
                backgroundColor: "#f0f7ff",
                borderRadius: "8px",
                marginBottom: "16px",
              }}
            >
              <span style={{ fontSize: "14px", color: "#666" }}>단가</span>

            </div>
          )} */}

          {/* 상세 설명 */}
          {item.description && (
            <div
              style={{
                backgroundColor: "#f9f9f9",
                borderRadius: "10px",
                padding: "16px",
                marginBottom: "24px",
                fontSize: "14px",
                lineHeight: "1.7",
                color: "#444",
                whiteSpace: "pre-line",
              }}
            >
              {item.description}
            </div>
          )}

          {/* 카트에 담기 버튼 */}
          <button
            onClick={() => {
              onAddToCart(item);
              onClose();
            }}
            style={{
              width: "100%",
              padding: "14px",
              backgroundColor: "#1976d2",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            카트에 담기
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetailModal;
